import { createRoot } from 'react-dom/client';
import App from './App';

const container = document.getElementById('app');
if (container !== null) {
  createRoot(container).render(<App />);
}
